module.exports = __webpack_public_path__ + "img/twitter-x-circle.ee50d562.svg";